import Client from '@/repositories/clients/AuthenticatedScrumbleApiClient';

export default {
  orderbook() { return Client.post('user/orderbook-checkout'); },
  quote(payload) { return Client.post('me/purchases', payload); },
  get(id) { return Client.get(`me/purchases/${encodeURIComponent(id)}`); },
  checkout(id, returnPath) { return Client.post(`me/purchases/${encodeURIComponent(id)}/checkout`, { return_path: returnPath }); },
};
